import React, { Component } from 'react';
import { withRouter } from '../../../util/withRouter';
import { Button } from 'react-bootstrap';
import Header from '../../../components/Header/Header';
import Confirm from '../../../components/Confirm/Confirm';

import profileIcon from '../../../assets/img/profile-icon.svg';
import deleteIcon from '../../../assets/img/user.svg';

// Import Style
import '../style.scss';

class WelcomePage extends Component {

  createOwnAccount = () => {
    global.window &&
      window.location &&
      window.location.replace(
        `/api/account/createaccount?user=${this.props.location.query.user}${
          this.props.location.query.app ? `&app=${this.props.location.query.app}` : ''
        }${
          this.props.location.query.host ? `&host=${this.props.location.query.host}` : ''
        }`
      );
  };

  requestAccess = () => {
    global.window &&
      window.location &&
      window.location.replace(
        `/api/account/requestaccess?acc=${this.props.location.query.acc}&user=${this.props.location.query.user}${
          this.props.location.query.app ? `&app=${this.props.location.query.app}` : ''
        }${
          this.props.location.query.host ? `&host=${this.props.location.query.host}` : ''
        }`
      );
  };

  joinAccount = () => {
    global.window &&
      window.location &&
      window.location.replace(
        `/api/account/join?acc=${this.props.location.query.acc}&user=${this.props.location.query.user}${
          this.props.location.query.app ? `&app=${this.props.location.query.app}` : ''
        }${this.props.location.query.iid ? `&iid=${this.props.location.query.iid}` : ''}`
      );
  };

  joinPartnerAccount = () => {
    global.window &&
      window.location &&
      window.location.replace(
        `/api/account/joinpartner?user=${this.props.location.query.user}${
          this.props.location.query.app ? `&app=${this.props.location.query.app}` : ''
        }${
          this.props.location.query.uid ? `&uid=${this.props.location.query.uid}` : ''
        }${
          this.props.location.query.acc ? `&acc=${this.props.location.query.acc}` : ''
        }`
      );
  };

  render() {
    return (
      <div className='main welcome'>
        <Header title="" showHome={false} />
        <div className='select-host-container'>
          <div className='select-host-head'>
            <h1>Welcome!</h1>
            {this.props.location.query.uid ? (
              <p>
                We have noticed that there is an existing partner account under your email.
              </p>
            ) : !this.props.location.query.iid ? (
              <React.Fragment>
                <p>
                  We have noticed that there is an existing corporate account under your domain.
                </p>
                <p>
                  How would you like to proceed?
                </p>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <p>
                  You have a pending invitation to your corporate account.
                </p>
                <p>
                  How would you like to proceed?
                </p>
              </React.Fragment>
            )}
          </div>
          <div className='select-host-item select-host-welcome-item'>
            <div className='select-host-item-content'>
              <div className='message'>
                { this.props.location.query.uid
                  ? 'I would like to use my partner account.'
                  : !this.props.location.query.iid
                  ? 'I would like to request access to my corporate account.'
                  : 'I would like to join our corporate account.'}
              </div>
              <div className='icon'>
                <img src={profileIcon} alt="" />
              </div>
            </div>
            {this.props.location.query.uid ? (
              <Button onClick={() => this.joinPartnerAccount()}>
                Use partner account
              </Button>   
            ) : !this.props.location.query.iid ? (
              <Button onClick={() => this.requestAccess()}>
                Request access
              </Button>
            ) : (
              <Button onClick={() => this.joinAccount()}>
                Join account
              </Button>
            )}
          </div>
          <Confirm
            onConfirm={() => this.createOwnAccount()}
            body={
              <p>
                This action will create a new account that expires in 14 days. <br/>
                Are you sure you want to proceed?
              </p>
            }
            confirmClass="btn btn-primary"
            confirmText="Create Account"
            icon={deleteIcon}
            title="You're about to create your own trial account"
          >
            <div className='link'>
              No thanks, I'd like to create my own account
            </div>
          </Confirm>
        </div>
      </div>
    );
  }
}

export default withRouter(WelcomePage);
